export default () => '<div class="content">Foundation diameter for concrete foundation can be selected for your equipment or preference. Smaller diameters will often require deeper foundation depths.</div>';
